module.exports = __webpack_public_path__ + "static/footer_check_sp-93b6d466b36b1dae5f01c3ce819652c1.jpg";